import { render, staticRenderFns } from "./CompanyGovernmentHolidaysForSystem.vue?vue&type=template&id=df327a58"
import script from "./CompanyGovernmentHolidaysForSystem.vue?vue&type=script&lang=js"
export * from "./CompanyGovernmentHolidaysForSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports